module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Expander"
  }, [_c('div', {
    staticClass: "custaccordian",
    attrs: {
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingOne"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('a', {
    attrs: {
      "data-toggle": "",
      "data-parent": "#filteraccordian",
      "href": '#' + _vm.id,
      "aria-expanded": "false",
      "aria-controls": _vm.id
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.title) + " "), _c('span', {
    staticClass: "dselect"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])]), _vm._v(" "), _c('div', {
    staticClass: "maxer card-detail collapse",
    class: {
      'in': _vm.expand
    },
    attrs: {
      "id": _vm.id,
      "role": "tabpanel",
      "aria-labelledby": "headingOne"
    }
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6bbaae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/vue-accordian.vue
// module id = 1102
// module chunks = 111